<!-- src/components/OnlineCustomerService.vue -->
<template>
  <el-dialog
    v-model="visible"
    width="1000px"
    @update:modelValue="$emit('update:modelValue', $event)"
  >
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <div style="font-size: 20px;font-weight: 600;color:#0066BA">在线客服
          <span style="font-weight: 400;font-size: 14px;"> ( 在线时间 08:30 - 17:30 )</span>
        </div>
      </div>
    </template>
    
    <div v-for="(item,index) in onLineData" :key="index">
      <div style="margin-top:20px;margin-bottom:10px">
        <span style="font-weight: 600;font-size: 18px;color:#0066BA">{{item.title}}</span>
      </div>
      <div style="margin-bottom:10px;display: flex;justify-content: space-between;padding:0px 20px;align-items: center;" v-for="(i,v) in item.children" :key="v">
        <div>
          <div style="margin-bottom:5px;color:#000;">{{i.title}}</div>
          <el-tag>{{i.phone}}</el-tag>
        </div>
        <div style="display: flex;flex-direction: column;align-items: center;"> 
          <el-tag>
            <a :href="'http://wpa.qq.com/msgrd?v=3&amp;uin='+i.uni+'&amp;site=qq&amp;menu=yes'" class="qq_link" target="_blank">
              <span>在线咨询 ({{ i.uni }})</span>
            </a>
          </el-tag>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref,computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const visible = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})
const onLineData = ref([
  {
    title:'华北区',
    children:[
      { title:'北京市', phone:'18621169131', uni:'2881323318' },
      { title:'天津市', phone:'18621169011', uni:'2881323305' },
      { title:'河北省、辽宁省', phone:'18621160552', uni:'2881323330' },
      { title:'黑龙江省、吉林省', phone:'18621169110', uni:'2881323316' }
    ]
  },
  {
    title:'华东区',
    children:[
      { title:'上海市（除浦东，嘉定，杨浦）企业，安徽企业，河南企业', phone:'18621169105', uni:'2881323300' },
      { title:'安徽高校', phone:'18621160058', uni:'2881963635' },
      { title:'河南高校', phone:'18621169121', uni:'2881323327' },
      { title:'上海浦东、湖北省、江西省', phone:'18621169085', uni:'2881323328' },
      { title:'浙江省', phone:'18621169035', uni:'2881323317' },
      { title:'江苏企业', phone:'18621169117', uni:'2881323324' },
      { title:'江苏高校', phone:'18621161058', uni:'2885033266' },
      { title:'上海临港、山东省、甘肃省、宁夏、青海、西藏', phone:'18621169066', uni:'2881323320' },
      { title:'上海嘉定区、杨浦区、陕西省、山西省、内蒙古', phone:'18621169075', uni:'2881323306' },
      { title:'湖南、四川、重庆', phone:'18621169107', uni:'2881323329' }
    ] 
  },
  {
    title:'华南区',
    children:[
      { title:'广州、福建、海南、云南', phone:'18621169113', uni:'2881323311' },
      { title:'广东（除广州）、广西、贵州', phone:'18621169106', uni:'2881323314' }
    ] 
  },
  {
    title:'国际贸易',
    children:[
      { title:'香港、澳门、台湾、海外其他客户', phone:'2881323309', uni:'2881323309' }
    ] 
  },
    {
    title:'百生跃品牌咨询',
    children:[
      { title:'', phone:'13585762438', uni:'915322476' }
    ] 
  },
])
</script>

<style scoped>
.qq_link span {
  background: url(@/assets/QQ.png) no-repeat center left;
  background-size: 16px 16px;
  padding-left: 17px;
  color:#000;
  font-size: 13px;
}

::v-deep .el-tag.el-tag--primary{
  padding:13px !important
}
a{
  text-decoration: none;
}
</style>